import { Routes } from '@angular/router';
import { HomeChildComponent } from './components/home/home-child.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';
import { SettingsComponent } from './components/settings/settings.component';
import { HelpComponent } from './components/help/help.component';
import { Onboarding1Component } from './components/onboarding1/onboarding1.component';
import { Onboarding2Component } from './components/onboarding2/onboarding2.component';
import { Onboarding3Component } from './components/onboarding3/onboarding3.component';
import { ModuleStartComponent } from './components/module-start/module-start.component';
import { ModuleTakeComponent } from './components/module-take/module-take.component';
import { ModuleEndComponent } from './components/module-end/module-end.component';
import { SurveyComponent } from './components/survey/survey.component';
import { istpGuard } from './guards/istp.guard';
import { HomeTeacherParentComponent } from './components/home-teacher-parent/home-teacher-parent.component';
import { ParcoursTeacherParentComponent } from './components/parcours-teacher-parent/parcours-teacher-parent.component';
import { FollowUpComponent } from './components/follow-up/follow-up.component';
import { TeachingSheetsComponent } from './components/teaching-sheets/teaching-sheets.component';
import { SignupComponent } from './components/signup/signup.component';
import { VerifyComponent } from './components/verify/verify.component';
import { Onboarding4Component } from './components/onboarding4/onboarding4.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { PaymentCancelComponent } from './components/payment-cancel/payment-cancel.component';
import { BridgeComponent } from './components/bridge/bridge.component';
import { DatapolicyComponent } from './components/datapolicy/datapolicy.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { FollowUpParentComponent } from './components/follow-up-parent/follow-up-parent.component';
import { BridgeAnonymousComponent } from './components/bridge-anonymous/bridge-anonymous.component';
import { helpAvailabilityGuard } from './guards/help-availability.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'hometp', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'signup-before-purchase', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'datapolicy', component: DatapolicyComponent },
  { path: 'verify/:token', component: VerifyComponent },
  { path: 'bridge/:mobile/:token', component: BridgeComponent },
  { path: 'anobridge/:mobile/:token', component: BridgeAnonymousComponent },
  {
    path: 'homec',
    component: HomeChildComponent,
    canActivate: [authGuard],
  },
  { path: 'help', component: HelpComponent, canActivate: [authGuard, helpAvailabilityGuard] },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'survey',
    component: SurveyComponent,
    canActivate: [authGuard],
  },
  {
    path: 'onboarding/1',
    component: Onboarding1Component,
    canActivate: [authGuard],
  },
  {
    path: 'onboarding/2',
    component: Onboarding2Component,
    canActivate: [authGuard],
  },
  {
    path: 'onboarding/3',
    component: Onboarding3Component,
    canActivate: [authGuard],
  },
  {
    path: 'onboarding/4',
    component: Onboarding4Component,
    canActivate: [authGuard],
    data: { canSkip: true },
  },
  {
    path: 'offers',
    component: Onboarding4Component,
    canActivate: [authGuard],
  },
  {
    path: 'update_avatar',
    component: Onboarding2Component,
    canActivate: [authGuard],
  },
  {
    path: 'module_start/:id',
    component: ModuleStartComponent,
    canActivate: [authGuard],
  },
  {
    path: 'module_take/:id',
    component: ModuleTakeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'module_end/:id',
    component: ModuleEndComponent,
    canActivate: [authGuard],
  },
  {
    path: 'payment_success',
    component: PaymentSuccessComponent,
    canActivate: [authGuard],
  },
  {
    path: 'payment_cancel',
    component: PaymentCancelComponent,
    canActivate: [authGuard],
  },
  {
    path: 'hometp',
    component: HomeTeacherParentComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'module_start_tp/:color/:id',
    component: ModuleStartComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'module_take_tp/:color/:id',
    component: ModuleTakeComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'module_end_tp/:color/:id',
    component: ModuleEndComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'parcourstp',
    component: ParcoursTeacherParentComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'follow_up',
    component: FollowUpComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'follow_up_parent',
    component: FollowUpParentComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'teaching_sheets',
    component: TeachingSheetsComponent,
    canActivate: [authGuard, istpGuard],
  },
  {
    path: 'helptp',
    component: HelpComponent,
    canActivate: [authGuard, istpGuard, helpAvailabilityGuard],
  },
  { path: '**', redirectTo: 'hometp' },
];
